/*
  Makes a class mapper that takes the map of classes (exported by LESS-loader) as an argument and
  returns a function that takes an array of strings as an argument. Function returns a class name string
  separated with spaces. Useful when working with CSSModules, which generates hashed class names.
*/

import { compose, join, reject, isNil, props, __ } from 'ramda';

export default classMap => compose(join(' '), reject(isNil), props(__, classMap));
